import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=633211a2&scoped=true&"
import script from "./CityList.vue?vue&type=script&lang=js&"
export * from "./CityList.vue?vue&type=script&lang=js&"
import style0 from "./CityList.vue?vue&type=style&index=0&id=633211a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633211a2",
  null
  
)

export default component.exports